<template functional>
    <div class="no-data"
         :class="[{'no-data-jumbo' : props.jumbo}, {'no-data--shadow' : props.shadow}]"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    functional: true,
    props: {
        title: {
            type: String,
            default: "",
        },
        jumbo: {
            type: Boolean,
            default: true,
        },
        shadow: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.no-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 24px;
    color: #9e9e9f;
    font-weight: 500;

    &__message {
        margin-top: 8px;
    }

    &-jumbo {
        border-radius: 16px;
        background-color: #ffffff;
        height: 256px;
    }

    &--shadow {
        box-shadow: 0 0 8px 0 rgba(193, 192, 196, 0.35);
    }

    img {
        user-select: none;
    }
}
</style>
